
import { defineComponent } from 'vue'
import RandomNumberCard from '../components/RandomNumberCard.vue'
import { get10RandomNumbers } from '@/services/KoreanDataService'

export default defineComponent({
  name: 'Random',
  components: {
    RandomNumberCard,
  },
  data() {
    return {
      randomKoreanNumbers: get10RandomNumbers(),
      index: Math.random().toString(36).substring(7),
    }
  },
  methods: {
    reload() {
      this.randomKoreanNumbers = get10RandomNumbers()
      this.index = Math.random().toString(36).substring(7)
    },
  },
})
